/*
 * Copyright (c) 2026 Tezi Communications LLP, India
 * All rights reserved. Private and Confidential.
 */
import { LoadingSpinner } from "@connected-repo/ui-mui/components/LoadingSpinner";
import { ThemeContextProvider, useThemeMode } from "@connected-repo/ui-mui/theme/ThemeContext";
import { ErrorFallback } from "@frontend/components/error_fallback";
import { usePWAInstall } from "@frontend/sw/usePwaInstall.sw";
import { router } from "@frontend/router";
import { Suspense, useEffect, useState, lazy } from "react";
import { RouterProvider } from "react-router";
const ToastProvider = lazy(() => import("./components/providers/ToastProvider").then(m => ({ default: m.ToastProvider })));
const SentryBoundary = lazy(() => import("./components/providers/SentryBoundary").then(m => ({ default: m.SentryBoundary })));

// App focuses on rendering the router tree and error boundaries. Providers
// (QueryClient + oRPC client) are created and mounted at the root in
// `main.tsx` following the oRPC + TanStack React Query recommended setup.
// ToastProvider is now lazy-loaded
// SentryBoundary is now using a truly lazy wrapper logic below

function App() {

	usePWAInstall();
	
	return (
		<ThemeContextProvider>
			<Suspense fallback={<LoadingSpinner fullScreen text="ExpoWiz" subtext="Loading..." color="inherit" />}>
				<SentryBoundary>
					<RouterProvider router={router} />
					<ToastProvider />
				</SentryBoundary>
			</Suspense>
		</ThemeContextProvider>
	);
}

export default App;
